module.exports = __webpack_public_path__ + "img/gear-web-app-gray@3x.927a2a8f.png";